import React, { useState } from "react";
import LazyImage from "./LazyImage";
import Image1 from "../../assets/img/portfolio/portfolio-1.jpg";
import Image2 from "../../assets/img/portfolio/portfolio-2.jpg";
import Image3 from "../../assets/img/portfolio/portfolio-3.jpg";
import Image4 from "../../assets/img/portfolio/portfolio-4.jpg";
import Image5 from "../../assets/img/portfolio/portfolio-5.jpg";
import Image6 from "../../assets/img/portfolio/portfolio-6.jpg";
import Image7 from "../../assets/img/portfolio/portfolio-7.jpg";
import Image8 from "../../assets/img/portfolio/portfolio-8.jpg";
import Image9 from "../../assets/img/portfolio/portfolio-9.jpg";
import Image10 from "../../assets/img/portfolio/portfolio-10.jpg";

const PORTFOLIO_PROJECTS = [
	{
		id: 1,
		title: "Pishon Helping Hands",
		category: "Healthcare - Website Design",
		description:
			"Pishon Helping Hands is a highly trusted Canadian organization dedicated to empowering adults through compassionate care, fostering their independence and promoting overall well-being.",
		image: Image1,
		technologies: ["WordPress", "Elementor"],
		url: "https://www.pishonhelpinghands.com/",
		featured: true,
	},
	{
		id: 2,
		title: "BiteExpress Merch",
		category: "E-commerce - Online Store",
		description:
			"Explore BiteExpress Merch for a wide array of exclusive designs and premium products. Count on us for reliable service that perfectly matches your unique style preferences.",
		image: Image2,
		technologies: ["WordPress", "Elementor", "WooCommerce"],
		url: "https://store.bite.express/",
		featured: true,
	},
	{
		id: 3,
		title: "Pharmxtra",
		category: "Healthcare - Web Development",
		description:
			"Pharmxtra is a healthcare-oriented organization committed to delivering quality services with a focus on customer satisfaction and client contentment.",
		image: Image3,
		technologies: ["WordPress", "Elementor", "WooCommerce"],
		url: "https://www.pharmxtraservices.com/",
		featured: false,
	},
	{
		id: 4,
		title: "Manna Academy",
		category: "Education - Web Development",
		description:
			"Manna Academy is dedicated to igniting the minds of students and inspiring them for bright futures with a focus on academic excellence and character development.",
		image: Image4,
		technologies: ["WordPress", "Elementor", "Laravel", "PHP", "MySQL"],
		url: "https://www.mannaacademy.sch.ng/",
		featured: true,
	},
	{
		id: 5,
		title: "BiteExpress",
		category: "Food & Delivery - Web Development",
		description:
			"BiteExpress offers fast and flavorful food delivery, bringing your favorite meals right to your doorstep with a wide selection of restaurants.",
		image: Image5,
		technologies: ["React", "TailwindCSS"],
		url: "https://biteexpress.ng/",
		featured: true,
	},
	{
		id: 6,
		title: "DukeNPaul",
		category: "Corporate - Website Design",
		description:
			"A leading provider of signs for businesses, organizations, and individuals in Nigeria. Committed to excellent service and quality signage solutions.",
		image: Image6,
		technologies: ["WordPress", "Elementor"],
		url: "https://dukenpaulsignage.com/",
		featured: false,
	},
	{
		id: 7,
		title: "BiteExpress Web",
		category: "Mobile App - Development",
		description:
			"Get food, drinks, and more delivered with BiteExpress! Enjoy a diverse menu from top restaurants, delivered straight to you.",
		image: Image7,
		technologies: ["Flutter"],
		url: "https://web.biteexpress.ng/",
		featured: false,
	},
	{
		id: 8,
		title: "Kreador",
		category: "Social Network - Web Development",
		description:
			"Connect and collaborate with software engineers on our specialized social network app. Showcase projects and share knowledge in the ALX community.",
		image: Image8,
		technologies: ["Bootstrap", "HTML", "JavaScript"],
		url: "https://kreador.netlify.app",
		featured: false,
	},
	{
		id: 9,
		title: "URLShortener",
		category: "Web App - Development",
		description:
			"URLShortener is a convenient web app for creating short links from long URLs. Share easily on social media, email, and more.",
		image: Image9,
		technologies: ["React", "TailwindCSS", "Node.js", "MongoDB", "RESTful API"],
		url: "https://shortenmyurl.netlify.app/",
		featured: true,
	},
	{
		id: 10,
		title: "SoftNaija",
		category: "Agriculture - Website Design",
		description:
			"SoftNaija: Nourishing Communities, One Meal at a Time. Dedicated to building a supportive ecosystem that celebrates the power of food, people, and shared values.",
		image: Image10,
		technologies: ["WordPress", "Elementor"],
		url: "https://www.softnaija.ng/",
		featured: false,
	},
];

const PortfolioAlternating = () => {
	const [showAll, setShowAll] = useState(false);

	const displayedProjects = showAll
		? PORTFOLIO_PROJECTS
		: PORTFOLIO_PROJECTS.slice(0, 3);

	return (
		<div className='w-full'>
			{/* Projects List */}
			<div className='space-y-16'>
				{displayedProjects.map((project, index) => (
					<div
						key={project.id}
						className={`flex flex-col lg:flex-row items-center gap-8 ${
							index % 2 === 1 ? "lg:flex-row-reverse" : ""
						}`}>
						{/* Project Image */}
						<div className='w-full lg:w-3/5 relative'>
							<div className='relative group overflow-hidden'>
								<LazyImage
									src={project.image}
									alt={`${project.title} - ${project.category}`}
									className='w-full h-[500px] object-cover object-center group-hover:scale-105 transition-transform duration-500'
									width={600}
									height={500}
								/>
								<div className='absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300' />
							</div>
						</div>

						{/* Project Content */}
						<div className='w-full lg:w-1/2 p-8 space-y-4 relative'>
							{/* Border line - positioned at the edge where text meets image, extending beyond padding */}
							<div
								className={`hidden lg:block absolute -top-8 -bottom-8 w-px bg-gray-200 ${
									index % 2 === 1 ? "-left-px" : "-right-px"
								}`}></div>
							<div className='space-y-2'>
								<p className='text-sm text-gray-500 font-medium uppercase tracking-wide'>
									{project.category}
								</p>

								<h3 className='text-2xl lg:text-3xl font-bold text-gray-900 leading-tight'>
									{project.title}
								</h3>

								<p className='text-gray-600 leading-relaxed text-base'>
									{project.description}
								</p>
							</div>

							{/* Technologies */}
							<div className='flex flex-wrap gap-2'>
								{project.technologies.map((tech, techIndex) => (
									<span
										key={techIndex}
										className='text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full font-medium'>
										{tech}
									</span>
								))}
							</div>

							{/* Call to Action */}
							<div className='pt-2'>
								<a
									href={project.url}
									target='_blank'
									rel='noopener noreferrer'
									className='inline-flex items-center text-gray-900 font-semibold hover:text-gray-600 transition-colors duration-200 group'>
									Read more
									<div className='ml-2 w-6 h-6 bg-gray-900 flex items-center justify-center group-hover:bg-gray-600 transition-colors duration-200'>
										<svg
											className='w-3 h-3 text-white'
											fill='none'
											stroke='currentColor'
											viewBox='0 0 24 24'>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												strokeWidth={2}
												d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
											/>
										</svg>
									</div>
								</a>
							</div>
						</div>
					</div>
				))}
			</div>

			{/* More Projects Button */}
			{PORTFOLIO_PROJECTS.length > 3 && (
				<div className='mt-16 text-center'>
					<button
						onClick={() => setShowAll(!showAll)}
						className='bg-gray-900 text-white px-8 py-4 font-semibold text-sm uppercase tracking-wide hover:bg-gray-800 transition-colors duration-200'>
						{showAll ? "BROWSE LESS" : "BROWSE ALL"}
					</button>
				</div>
			)}
		</div>
	);
};

export default PortfolioAlternating;
